import React from 'react';

class LexSlider extends React.Component {
  render() {
    const {
      label,
      hint,
      min = 0,
      max = 100,
      step = 1,
      value,
      onChange,
      attribute,
      formatValue,
    } = this.props;

    const displayValue = formatValue ? formatValue(value) : value;
    const fillPercent = ((value - min) / (max - min)) * 100;

    return (
      <div className="lex-field lex-slider">
        <div className="lex-slider__header">
          <p className="lex-field__label">{label}</p>
          <span className="lex-slider__value">{displayValue}</span>
        </div>
        {hint && <p className="lex-field__hint">{hint}</p>}
        <div className="lex-slider__track-wrap">
          <div className="lex-slider__track" aria-hidden="true">
            <div className="lex-slider__fill" style={{ width: `${fillPercent}%` }} />
          </div>
          <input
            type="range"
            className="lex-slider__input"
            min={min}
            max={max}
            step={step}
            value={value}
            onChange={(e) => onChange(Number(e.target.value), attribute)}
          />
        </div>
      </div>
    );
  }
}

export default LexSlider;
